// extracted by mini-css-extract-plugin
export var base = "_51-0";
export var updateBanner = "_51-1";